import { cnpjValidator } from './cnpj.validator';
import { cpfValidator } from './cpf.validator';
import { urlValidator } from './url.validator';
import { dateValidator } from './date.validator';
import { confirmarSenhaValidator } from './confirmar-senha.validator';

const CustomValidators = {
  cpf: cpfValidator,
  cnpj: cnpjValidator,
  url: urlValidator,
  data: dateValidator,
  confirmarSenha: confirmarSenhaValidator
};

export { CustomValidators };
